module.exports = __webpack_public_path__ + "img/logo.7678f3ce.png";